export default "__VITE_ASSET__BfEYkU9B__"